import React, { useState, useRef } from "react"
import styled from 'styled-components';
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-intl"
import { useOnClickOutside } from '../../hooks';
import { device } from "../../device";

const languageName = {
  en: "Eng",
  ru: "Рус",
  uk: "Укр",
}

const Switcher = styled.div`
    display: none;
    @media ${device.lg} {
        position: relative;
    
        display: block;
        
        transition: color .3s ease;
        &:after {
            position: absolute;
            top: 0;
            left: 0;

            height: 100%;
            width: 100%;

            border: 1px solid var(--midle-gray1);
            border-radius: 15px;
            content: '';

            transition: border .3s ease;
        }

        .dark & {
            color: #fff;
            &:after {
                border-color: var(--midle-gray3);
            }
        }
    }
    
`;
const CurrentLang = styled.button`
    @media ${device.lg} {
        position: relative;
        z-index: 2;
    
        height: 30px;
        width: 64px;
        padding: 0 0 0 14px;
    
        font-size: 14px;
        text-align: left;
    
        background: transparent;
        border: 0;
        color: inherit;
        &:after {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translate(0, -50%);
            
            content: '';
            
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4.5px solid var(--brand);
            transition: border .3s ease;
            .dark & {
                border-top: 4.5px solid #fff;
            }
        }
        &:focus {
            outline: none;
        }
    }
`;
const LangList = styled.ul`
    @media ${device.lg} {
        left: 0;
        top: 0;
        position: absolute;
        z-index: 1;

        width: 64px;
        margin: 0;
        padding: 30px 0 0;

        background: var(--light-gray2);
        border: 1px solid var(--midle-gray1);
        border-radius: 15px;
        list-style: none;
        opacity: 0;
        visibility: hidden; 
        overflow: hidden;

        transition: opacity .1s ease-in-out, background .3s ease, border .3s ease;
        .dark & {
            background: var(--brand);
            border: 1px solid var(--midle-gray3);
        }
        &.open {
            opacity: 1;
            visibility: visible; 
        }
    }
`;
const LangLink = styled.a`
    @media ${device.lg} {
        display: block;
        padding: 8px 12px;
    
        font-size: 14px;
        line-height: 1;
    
        color: inherit;
        cursor: pointer;
        
        &:hover,
        &:focus {
            background: var(--light-gray3);
            color: inherit;
            .dark & {
                background: var(--dark-gray1);
            }
        }
    }
`;

const LanguageSwitcherDesk = () => {
    
    const [isOpen, setIsOpen] = useState(false);
    const node = useRef();
    useOnClickOutside(node, () => setIsOpen(false));
    return (
        <IntlContextConsumer>
            {({ languages, language: currentLocale }) => (
                <Switcher role="listbox" aria-expanded="true" id="langSwitch">
                    <CurrentLang onClick={() => setIsOpen(!isOpen)}>
                        {languageName[currentLocale]}
                    </CurrentLang>
                    <LangList className={isOpen ? 'open': null} ref={node}>
                        {languages.map(language => {
                            if (currentLocale !== language) {
                                return <li key={language}><LangLink 
                                    onClick={() => changeLocale(language)}
                                    role="option" 
                                    aria-checked="true" 
                                    aria-selected="true">
                                        {languageName[language]}
                                </LangLink></li>
                            } else {
                                return null;
                            }
                        })}
                    </LangList>
                </Switcher>
                )
            }
        </IntlContextConsumer>
    )
}

export default LanguageSwitcherDesk;